const root = "/subscriptions";

export const subscriptionIdRouteParam = "subscriptionId";

export const subscriptionRoutes = {
  root: root,
  add: `${root}/add`,
  detail: (id: string) => ({
    root: `${root}/${id}`,
    edit: `${root}/${id}/edit`,
    history: `${root}/${id}/history`,
    deactivationHistory: `${root}/${id}/deactivation-history`,
    userAccess: `${root}/${id}/user-access`,
    addUserAccess: `${root}/${id}/user-access/assign`,
    addGroupUserAccess: `${root}/${id}/user-access/subscription-group/:subscriptionGroupId/assign`,
    addExistingSubscriptionGroup: `${root}/${id}/user-access/subscription-group/add-existing`,
    addNewSubscriptionGroup: `${root}/${id}/user-access/subscription-group/add-new`,
    ipAddressAllowList: `${root}/${id}/ip-address-allow-list`,
    licenseEmails: `${root}/${id}/license-emails`,
    rateCard: `${root}/${id}/rate-card`,
  }),
};
